import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import GroupListFilter from './group-list-filter'
import groupType from './group-type'
import PrincipalList from '../principal-list'
import Sifter from 'scoreboard/components/scoreboard-sifter'
import Tooltip from 'scoreboard/components/tooltip'
import groupListItem from './group-list-item.hbs'

var GroupList = PrincipalList.extend({

	// this.options.groupId is the ID of the selected group (if there is one)

	// this.options.stream is the stream of groups

	className: 'panel group-panel left-panel',

	events: _.extend({}, PrincipalList.prototype.events, {
		'click .filter': '_filter'
	}),

	showFilter: true,
	headingKey: 'admin.group.permissions',
	searchMessageKey: 'admin.group.search',

	_renderListItem: function(item, principal) {
		return groupListItem({
			index: item.id,
			principal: principal,
			groupType: groupType.label(principal.type),
			membersCount: principal.totalMembers || 0
		})
	},

	getSifterFields: function() {
		return ['id', 'label']
	},

	/**
	 * Overrides PrincipalList to filter the groups before the Sifter is applied.
	 * @param {array} groups the entire list of groups
	 * @return {array} groups to display
	 */
	preFilter: function(groups) {
		if (_.isUndefined(this.groupType)) {
			return groups
		}
		var matchingGroups = _.filter(groups, function(p) {
			return p.type === this.groupType
		}.bind(this))
		return matchingGroups
	},

	_filter: function(e) {
		var target = $(e.currentTarget)

		this.listFilterView = new GroupListFilter({
			// Get distinct types for the current list of principals
			typeLabels: _.map(_.uniqBy(this.principals, 'type'), 'type'),
			type: this.groupType,
			sortDirection: this.sortDirection
		})

		this.filterTooltip = new Tooltip({
			attachTo: target,
			content: this.listFilterView,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu filter-tooltip'
		}).render()


		this.listenTo(this.listFilterView, 'type', function(type){
			this.groupType = type
			this.filteredPrincipals = this.preFilter(this.principals)
			this.sifter = new Sifter(this.filteredPrincipals)
			this.find() // This reloads the result list
		}.bind(this))

		this.listenTo(this.listFilterView, 'sort', function(sortDirection){
			this.sortDirection = sortDirection
			this.find() // This reloads the result list
		}.bind(this))

	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.listFilterView, this.filterTooltip], 'remove')
	}

})

export default GroupList

GroupList.__filename__ = 'admin/principals/groups/group-list.js'
